module.exports = __webpack_public_path__ + "assets/img/IMG007.fe96ead6.png";